export { default } from './StatsItem';
